import { CssPropertyEnumCssPropertyType } from '@wix/ambassador-devcenter-components-v1-component/types';
import { border } from '../border/shorthandHandler';
import { corner } from '../corner/shorthandHandler';
import { spacing } from '../spacing/shorthandHandler';
import { text } from '../text/shorthandHandler';
import { decompose } from './decomposer';

const composeMap: Record<
  string,
  (values: Record<string, string | null>) => string | null
> = {
  ...border.composeMap,
  ...spacing.composeMap,
  ...text.composeMap,
  ...corner.composeMap,
};

export const compose = (
  cssPropertyType: string,
  values: Record<string, string | null>,
): string | null => {
  const composeFunction = composeMap[cssPropertyType];

  return composeFunction ? composeFunction(values) : null;
};

export const composeProperties = (
  definedStylesProperties: (CssPropertyEnumCssPropertyType | string)[],
  values: Record<string, string>,
): Record<string, string> => {
  const composedValues: Record<string, string> = {};

  definedStylesProperties.forEach((key) => {
    const existingValue = values[key];

    if (existingValue) {
      const decomposed = decompose(key, existingValue);
      const mergedValues = decomposed ? { ...decomposed, ...values } : values;
      const recomposed = compose(key, mergedValues);

      composedValues[key] = recomposed ?? existingValue;
      return;
    }

    const composed = compose(key, values);

    if (composed) {
      composedValues[key] = composed;
    }
  });

  return composedValues;
};
